<template>
  <div class="imgBox min-w-1400">
    <div class="imgBox1 min-w-1400">
      <div class="img1 max-w-1400" style="margin-bottom: 250px;" >
        <h2 class="bannerTitle">Trải nghiệm dịch vụ vay trực tuyến <br> cùng Lavi Finance</h2>
        <img :src="banner" :alt="altText" class="imgItem1" />
      </div>
    </div>
    <div class="imgBox2 min-w-1400">
      <div class="img2 max-w-1400">
        <section class="feature-section">
          <div class="feature-section__header">
            <h2 class="feature-section__title">Đặc điểm nổi bật</h2>
          </div>

          <div class="feature-list">
            <article
              v-for="feature in features"
              :key="feature.title"
              class="feature-card"
              :class="{ 'feature-card--reverse': feature.reverse }"
            >
              <div class="feature-card__visual">
                <img
                  :src="feature.image"
                  :alt="feature.title"
                  class="feature-card__image"
                />
              </div>

              <div class="feature-card__content">
                <h3 class="feature-card__title">{{ feature.title }}</h3>
                <p class="feature-card__text">{{ feature.text }}</p>
                <a href="https://apps.apple.com/vn/app/lavi-finance/id6741784212" type="button" class="feature-card__button">
                  Tải xuống ngay
                  <span>&rarr;</span>
                </a>
              </div>
            </article>
          </div>
        </section>
      </div>
    </div>
    <div class="imgBox3 min-w-1400">
        <div class="img3 max-w-1400">
          <section class="review-section">
            <div class="review-section__header">
              <h2 class="review-section__title">Trải nghiệm dịch vụ vay trực tuyến cùng Lavi Finance</h2>
            </div>

            <div class="review-hero">
              <div class="review-hero__content">
                <h3 class="review-hero__title">Lavi Finance – Ứng dụng hỗ trợ vay trực tuyến minh bạch</h3>
                <p class="review-hero__text">
Lavi Finance cung cấp giải pháp đăng ký vay trực tuyến với quy trình rõ ràng, thông tin khoản vay được hiển thị minh bạch và các bước xác nhận được thiết kế thuận tiện trên thiết bị di động.
                </p>

                <!-- <div class="review-hero__ratings">
                  <div class="store-rating">
                    <span class="store-rating__icon store-rating__icon--apple">A</span>
                    <span class="store-rating__score">4.8/5</span>
                    <span class="store-rating__count">82,000+ 评论</span>
                  </div>
                  <div class="store-rating">
                    <span class="store-rating__icon store-rating__icon--play">▶</span>
                    <span class="store-rating__score">4.6/5</span>
                    <span class="store-rating__count">80,000+ 评论</span>
                  </div>
                </div> -->

                <a href="https://apps.apple.com/vn/app/lavi-finance/id6741784212" type="button" class="review-hero__button">
                  Trải nghiệm ngay
                  <span>&rarr;</span>
                </a>
              </div>

              <!-- <div class="review-hero__banner-placeholder">
                <span>Banner Image</span>
              </div> -->
            </div>

            <div class="review-cards">
              <article
                v-for="review in appReviews"
                :key="review.name"
                class="review-card"
              >
                <h4 class="review-card__name">{{ review.name }}</h4>
                <div class="review-card__stars">★★★★★</div>
                <p class="review-card__text">{{ review.text }}</p>
              </article>
            </div>
          </section>
        </div>
    </div>
    <div class="imgBox4 min-w-1400">
        <div class="img4 max-w-1400" style="margin:0 auto;">
           <div class="container py-5">
        <div class="row justify-content-center">
            <div class="col-lg-8">
                <div class="text-center mb-5">
                    <h2 class="fw-bold display-6 text-dark mb-3">Giải đáp những thắc mắc bạn quan tâm nhất</h2>
                    <p class="text-muted fs-5"></p>
                    <div class="mt-4 mx-auto rounded-pill" style="width: 50px; height: 4px; background-color: #3b82f6;"></div>
                </div>

                <div class="accordion" :id="qaAccordionId">
                  <div
                    v-for="(item, index) in qaItems"
                    :key="item.question"
                    class="accordion-item border mb-2 rounded overflow-hidden bg-white shadow-sm"
                  >
                    <h2
                      class="accordion-header"
                      :id="qaAccordionId + '-heading-' + index"
                    >
                      <button
                        class="accordion-button fw-medium py-3"
                        :class="{ collapsed: activeQaIndex !== index }"
                        type="button"
                        :aria-expanded="activeQaIndex === index ? 'true' : 'false'"
                        :aria-controls="qaAccordionId + '-panel-' + index"
                        @click="toggleQaItem(index)"
                      >
                        {{ item.question }}
                      </button>
                    </h2>
                    <div
                      :id="qaAccordionId + '-panel-' + index"
                      class="accordion-collapse collapse"
                      :class="{ show: activeQaIndex === index }"
                      :aria-labelledby="qaAccordionId + '-heading-' + index"
                      :style="{ display: activeQaIndex === index ? 'block' : 'none' }"
                    >
                      <div class="accordion-body text-muted pt-2 pb-3 qa-answer">
                        <p
                          v-for="paragraph in item.answer"
                          :key="item.question + paragraph"
                          class="qa-answer__paragraph"
                        >
                          {{ paragraph }}
                        </p>
                      </div>
                    </div>
                  </div>
                </div>
            </div>
        </div>
      </div>
        </div>
    </div>
    <div class="imgBox5 min-w-1400">
        <div class="img5 max-w-1400">
          <section class="contact-section">
            <div class="contact-section__info">
              <article class="contact-info-card">
                <div class="contact-info-card__icon" aria-hidden="true">
                  <svg viewBox="0 0 24 24" fill="none">
                    <path d="M12 21s6-5.69 6-11a6 6 0 1 0-12 0c0 5.31 6 11 6 11Z" />
                    <circle cx="12" cy="10" r="2.5" />
                  </svg>
                </div>
                <div class="contact-info-card__body">
                  <h3 class="contact-info-card__title">Tên công ty:</h3>
                  <span class="contact-info-card__link">CÔNG TY TNHH MỘT THÀNH VIÊN QUẢN LÝ NỢ VÀ KHAI THÁC TÀI SẢN NGÂN HÀNG THƯƠNG MẠI CỔ PHẦN QUỐC TẾ VIỆT NAM</span>
                </div>
              </article>

              <article class="contact-info-card">
                <div class="contact-info-card__icon" aria-hidden="true">
                  <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round">
                    <!-- 定位外圆 + 尖头 -->
                    <path d="M12 2C8.13 2 5 5.13 5 9c0 7 7 13 7 13s7-6 7-13c0-3.87-3.13-7-7-7z" />
                    <!-- 中心点小圆 -->
                    <circle cx="12" cy="9" r="3" />
                  </svg> 
                </div>
                <div class="contact-info-card__body">
                  <h3 class="contact-info-card__title">Địa chỉ :</h3>
                   <a href="mailto:info@hdbank.com.vn" class="contact-info-card__email">4 Ton That Tung Street, Coninco Tower Building, Floor 12, Kim Lien Ward Vietnam</a>
                  <!-- <p class="contact-info-card__text">21/3 Tran Phu</p>
                  <p class="contact-info-card__text">Ward 3</p>
                  <p class="contact-info-card__text">Da Lat</p> -->
                </div>
              </article>

              <article class="contact-info-card">
                <div class="contact-info-card__icon" aria-hidden="true">
                  <svg viewBox="0 0 24 24" fill="none">
                    <path d="M21 16.2v3a2 2 0 0 1-2.18 2 19.8 19.8 0 0 1-8.63-3.07 19.52 19.52 0 0 1-6-6A19.8 19.8 0 0 1 1.12 3.5 2 2 0 0 1 3.11 1.3h3a2 2 0 0 1 2 1.72l.35 2.71a2 2 0 0 1-.57 1.72L6.6 8.74a16 16 0 0 0 8.66 8.66l1.29-1.29a2 2 0 0 1 1.72-.57l2.71.35A2 2 0 0 1 21 16.2Z" />
                  </svg>
                </div>
                <div class="contact-info-card__body">
                  <h3 class="contact-info-card__title">Điện thoại </h3>
                  <a href="tel:19006060" class="contact-info-card__hotline">+84 916230656</a>
                </div>
              </article>

              <article class="contact-info-card">
                <div class="contact-info-card__icon" aria-hidden="true">
                  <svg viewBox="0 0 24 24" fill="none">
                    <path d="M4 6h16v12H4z" />
                    <path d="m4 7 8 6 8-6" />
                  </svg>
                </div>
                <div class="contact-info-card__body contact-info-card__body--inline">
                  <h3 class="contact-info-card__title">Thư:</h3>
                  <a href="mailto:info@hdbank.com.vn" class="contact-info-card__email">service@lavifinance.com</a>
                </div>
              </article>
              <article class="contact-info-card">
                <div class="contact-info-card__icon" aria-hidden="true">
                  <svg viewBox="0 0 24 24" fill="none">
                    <circle cx="12" cy="12" r="9" />
                    <path d="M12 7v5l3.5 2" />
                  </svg>
                   
                </div>
                <div class="contact-info-card__body contact-info-card__body--inline">
                  
                  <h3 class="contact-info-card__title">Thời gian liên lạc:</h3>
                   <a href="mailto:info@hdbank.com.vn" class="contact-info-card__email">Thứ Hai – Thứ Sáu: 08:00 – 20:00</a>
                </div>
              </article>
            </div>

            <div class="contact-form-shell">
              <div class="contact-form-card">
                <div class="contact-form-card__tab">
                  <div class="contact-form-card__tab-label">Gửi email</div>
                  <div class="contact-form-card__tab-icon" aria-hidden="true">
                    <svg viewBox="0 0 24 24" fill="none">
                      <path d="M4 7h16v10H4z" />
                      <path d="m4 8 8 6 8-6" />
                    </svg>
                  </div>
                </div>

                <p class="contact-form-card__intro">
                  Nếu bạn có bất kỳ yêu cầu, đề xuất, lời khen hoặc phản hồi nào, vui lòng gửi email trực tiếp cho chúng tôi.
                </p>

                <form class="contact-form" @submit.prevent="handleContactSubmit">
                  <div class="contact-form__audience">
                    <span class="contact-form__audience-label">Bạn là khách hàng</span>
                    <div class="contact-form__audience-options">
                      <label class="contact-type">
                        <input
                          class="contact-type__input"
                          type="radio"
                          name="contactAudience"
                          value="personal"
                          v-model="contactAudience"
                          :disabled="isContactSubmitting"
                        />
                        <span class="contact-type__control" aria-hidden="true"></span>
                        <span class="contact-type__text">Cá nhân</span>
                      </label>

                      <label class="contact-type">
                        <input
                          class="contact-type__input"
                          type="radio"
                          name="contactAudience"
                          value="business"
                          v-model="contactAudience"
                          :disabled="isContactSubmitting"
                        />
                        <span class="contact-type__control" aria-hidden="true"></span>
                        <span class="contact-type__text">Doanh nghiệp</span>
                      </label>
                    </div>
                  </div>

                  <div class="contact-form__row contact-form__row--half">
                    <div class="contact-form__field-group">
                      <label
                        class="contact-field"
                        :class="{ 'contact-field--error': contactErrors.name }"
                      >
                        <span class="contact-field__icon" aria-hidden="true">
                          <svg viewBox="0 0 24 24" fill="none">
                            <path d="M12 12a4 4 0 1 0 0-8 4 4 0 0 0 0 8Z" />
                            <path d="M4.5 20a7.5 7.5 0 0 1 15 0" />
                          </svg>
                        </span>
                        <input
                          v-model.trim="contactForm.name"
                          class="contact-field__input"
                          type="text"
                          placeholder="Họ và tên"
                          :disabled="isContactSubmitting"
                          @input="clearContactError('name')"
                        />
                      </label>
                      <span v-if="contactErrors.name" class="contact-field__error">
                        {{ contactErrors.name }}
                      </span>
                    </div>

                    <div class="contact-form__field-group">
                      <label
                        class="contact-field"
                        :class="{ 'contact-field--error': contactErrors.phone }"
                      >
                        <span class="contact-field__icon" aria-hidden="true">
                          <svg viewBox="0 0 24 24" fill="none">
                            <path d="M21 16.2v3a2 2 0 0 1-2.18 2 19.8 19.8 0 0 1-8.63-3.07 19.52 19.52 0 0 1-6-6A19.8 19.8 0 0 1 1.12 3.5 2 2 0 0 1 3.11 1.3h3a2 2 0 0 1 2 1.72l.35 2.71a2 2 0 0 1-.57 1.72L6.6 8.74a16 16 0 0 0 8.66 8.66l1.29-1.29a2 2 0 0 1 1.72-.57l2.71.35A2 2 0 0 1 21 16.2Z" />
                          </svg>
                        </span>
                        <input
                          v-model.trim="contactForm.phone"
                          class="contact-field__input"
                          type="tel"
                          placeholder="Số điện thoại"
                          :disabled="isContactSubmitting"
                          @input="clearContactError('phone')"
                        />
                      </label>
                      <span v-if="contactErrors.phone" class="contact-field__error">
                        {{ contactErrors.phone }}
                      </span>
                    </div>
                  </div>

                  <div class="contact-form__row">
                    <div class="contact-form__field-group contact-form__field-group--full">
                      <label
                        class="contact-field contact-field--full"
                        :class="{ 'contact-field--error': contactErrors.email }"
                      >
                        <span class="contact-field__icon" aria-hidden="true">
                          <svg viewBox="0 0 24 24" fill="none">
                            <path d="M4 6h16v12H4z" />
                            <path d="m4 7 8 6 8-6" />
                          </svg>
                        </span>
                        <input
                          v-model.trim="contactForm.email"
                          class="contact-field__input"
                          type="email"
                          placeholder="Email"
                          :disabled="isContactSubmitting"
                          @input="clearContactError('email')"
                        />
                      </label>
                      <span v-if="contactErrors.email" class="contact-field__error">
                        {{ contactErrors.email }}
                      </span>
                    </div>
                  </div>

                  <div class="contact-form__row">
                    <div class="contact-form__field-group contact-form__field-group--full">
                      <label
                        class="contact-field contact-field--textarea"
                        :class="{ 'contact-field--error': contactErrors.message }"
                      >
                        <span class="contact-field__icon" aria-hidden="true">
                          <svg viewBox="0 0 24 24" fill="none">
                            <path d="M7 17h10" />
                            <path d="M7 12h10" />
                            <path d="M7 7h6" />
                            <path d="M5 3h14a2 2 0 0 1 2 2v14l-4-2H5a2 2 0 0 1-2-2V5a2 2 0 0 1 2-2Z" />
                          </svg>
                        </span>
                        <textarea
                          v-model.trim="contactForm.message"
                          class="contact-field__input contact-field__textarea"
                          rows="7"
                          placeholder="Nội dung tin nhắn"
                          :disabled="isContactSubmitting"
                          @input="clearContactError('message')"
                        ></textarea>
                      </label>
                      <span v-if="contactErrors.message" class="contact-field__error">
                        {{ contactErrors.message }}
                      </span>
                    </div>
                  </div>

                  <div class="contact-form__actions">
                    <button
                      type="submit"
                      class="contact-form__submit"
                      :disabled="isContactSubmitting"
                    >
                      <span class="contact-form__submit-icon" aria-hidden="true">→</span>
                      <span>{{ isContactSubmitting ? "Đang gửi..." : "Gửi" }}</span>
                    </button>
                  </div>
                </form>
              </div>

              <div
                v-if="isContactSuccessVisible"
                class="contact-modal"
                @click.self="closeContactSuccess"
              >
                <div
                  class="contact-modal__dialog"
                  role="dialog"
                  aria-modal="true"
                  aria-labelledby="contact-success-title"
                >
                  <button
                    type="button"
                    class="contact-modal__close"
                    aria-label="Close"
                    @click="closeContactSuccess"
                  >
                    ×
                  </button>
                  <div class="contact-modal__badge" aria-hidden="true">✓</div>
                  <h3 id="contact-success-title" class="contact-modal__title">
                    Tin nhắn đã được gửi
                  </h3>
                  <p class="contact-modal__text">
                    Chúng tôi đã nhận được nội dung của bạn và sẽ phản hồi sớm nhất có thể.
                  </p>
                  <button
                    type="button"
                    class="contact-modal__button"
                    @click="closeContactSuccess"
                  >
                    Đã hiểu
                  </button>
                </div>
              </div>
            </div>
          </section>
        </div>
    </div>

  </div>
</template>

<script>
import banner from "@/page/lavifinancecompany/components/img/banner-6.png";
import downloadFeatureImg1 from "@/page/lavifinancecompany/components/img/download-1.png";
import downloadFeatureImg2 from "@/page/lavifinancecompany/components/img/download-2.png";
import downloadFeatureImg3 from "@/page/lavifinancecompany/components/img/download-3.png";
import downloadFeatureImg4 from "@/page/lavifinancecompany/components/img/download-4.png";
import banner5 from "@/page/lavifinancecompany/components/img/banner-5.png";

const createEmptyContactForm = () => ({
  name: "",
  phone: "",
  email: "",
  message: "",
});

const qaItems = [
  {
    question: "Lavi Finance là gì?",
    answer: [
      "Lavi Finance là ứng dụng hỗ trợ người dùng tiếp cận và đăng ký khoản vay trực tuyến thông qua thiết bị di động.",
      "Thông qua ứng dụng, người dùng có thể tham khảo thông tin khoản vay, theo dõi kỳ hạn thanh toán, kiểm tra hồ sơ đã gửi và quản lý các nội dung liên quan trong cùng một tài khoản cá nhân.",
    ],
  },
  {
    question: "Tôi cần thực hiện những bước nào để đăng ký khoản vay tại Lavi Finance?",
    answer: [
      "Người dùng cần tải ứng dụng Lavi Finance, đăng ký tài khoản cá nhân và hoàn tất các thông tin theo hướng dẫn hiển thị trên hệ thống.",
      "Sau khi lựa chọn khoản vay phù hợp, người dùng có thể kiểm tra lại các nội dung liên quan trước khi gửi hồ sơ đăng ký để xét duyệt.",
    ],
  },
  {
    question: "Người dùng cần đáp ứng những điều kiện cơ bản nào để gửi hồ sơ?",
    answer: [
      "Người đăng ký cần là công dân Việt Nam đủ 18 tuổi trở lên, sở hữu giấy tờ tùy thân hợp lệ, tài khoản ngân hàng chính chủ và thông tin cá nhân đầy đủ theo yêu cầu của hệ thống.",
      "Ngoài ra, hồ sơ cần có các thông tin phục vụ cho quá trình đánh giá khả năng thanh toán và xét duyệt khoản vay.",
    ],
  },
  {
    question: "Tôi có thể xem trước số tiền vay, lãi suất và thời hạn thanh toán trước khi đăng ký không?",
    answer: [
      "Có. Trước khi hoàn tất hồ sơ, hệ thống sẽ hiển thị các nội dung tham khảo liên quan đến khoản vay như số tiền dự kiến, mức lãi suất áp dụng, kỳ hạn thanh toán và các chi phí liên quan.",
      "Người dùng có thể chủ động xem xét và cân nhắc tính phù hợp của khoản vay trước khi tiếp tục gửi hồ sơ.",
    ],
  },
  {
    question: "Kỳ hạn thanh toán của khoản vay tại Lavi Finance có linh hoạt không?",
    answer: [
      "Kỳ hạn thanh toán được hiển thị tương ứng với từng khoản vay mà hệ thống hỗ trợ.",
      "Người dùng có thể tham khảo trước thời gian thanh toán và lựa chọn phương án phù hợp hơn với khả năng thu nhập, kế hoạch chi tiêu và nhu cầu sử dụng vốn của mình.",
    ],
  },
  {
    question: "Hồ sơ gửi lên có chắc chắn được phê duyệt hay không?",
    answer: [
      "Kết quả xét duyệt không được đảm bảo cố định cho mọi hồ sơ.",
      "Việc phê duyệt sẽ phụ thuộc vào tính đầy đủ của thông tin người dùng cung cấp, điều kiện khoản vay đã lựa chọn và quy trình đánh giá của hệ thống tại từng thời điểm xử lý.",
    ],
  },
  {
    question: "Sau khi gửi hồ sơ, tôi có thể theo dõi tình trạng xử lý khoản vay ở đâu?",
    answer: [
      "Toàn bộ thông tin liên quan đến đơn vay, trạng thái xét duyệt, nội dung đã xác nhận và các thông báo cập nhật sẽ được hiển thị trong khu vực tài khoản cá nhân của người dùng trên ứng dụng.",
      "Người dùng có thể chủ động đăng nhập để kiểm tra lại bất cứ khi nào cần thiết.",
    ],
  },
  {
    question: "Khoản vay sau khi được phê duyệt sẽ được giải ngân như thế nào?",
    answer: [
      "Sau khi hồ sơ được xét duyệt thành công theo quy trình của hệ thống, khoản vay sẽ được chuyển đến tài khoản ngân hàng chính chủ mà người dùng đã cung cấp trong quá trình đăng ký.",
      "Người dùng nên đảm bảo thông tin tài khoản nhận tiền được khai báo chính xác để tránh ảnh hưởng đến quá trình xử lý.",
    ],
  },
];

export default {
  data() {
    return {
      altText: 'protocolTitle',
      banner: banner,
      banner5: banner5,
      qaAccordionId: "qa-lavi-finance",
      activeQaIndex: 0,
      qaItems,
      contactAudience: "personal",
      contactForm: createEmptyContactForm(),
      contactErrors: {},
      isContactSubmitting: false,
      isContactSuccessVisible: false,
      contactSubmitTimer: null,
      features: [
        {
          title: "Vay trực tuyến dễ tiếp cận",
          text: "Với Lavi Finance, bạn có thể gửi hồ sơ vay ngay trên điện thoại với quy trình rõ ràng và thao tác thuận tiện.",
          image: downloadFeatureImg1,
          reverse: false,
        },
        {
          title: "Thông tin khoản vay minh bạch",
          text: "Số tiền vay, kỳ hạn và lãi suất được hiển thị rõ ràng, giúp bạn tham khảo trước khi đăng ký.",
          image: downloadFeatureImg2,
          reverse: true,
        },
        {
          title: "Quy trình đăng ký rõ ràng",
          text: "Từ điền thông tin đến xác nhận khoản vay, mỗi bước đều có hướng dẫn rõ ràng.",
          image: downloadFeatureImg3,
          reverse: false,
        },
        {
          title: "Quản lý khoản vay thuận tiện",
          text: "Đơn vay, hợp đồng, lịch hẹn và thông tin hỗ trợ có thể được quản lý tập trung trong khu vực cá nhân.",
          image: downloadFeatureImg4,
          reverse: true,
        },
      ],
      appReviews: [
        {
          name: "Nguyễn Hoàng Nam ",
          text: "“Tôi thường làm việc cả ngày nên không có nhiều thời gian đi làm hồ sơ. Dùng Lavi Finance thì có thể xem thông tin khoản vay và gửi đăng ký ngay trên điện thoại, khá tiện.”",
        },
        {
          name: "Trần Thị Mai",
          text: "“Điều tôi thích ở ứng dụng này là nó hiển thị rõ ràng số tiền vay, thời hạn và các bước xác nhận. Sau khi xem xét lãi suất và thời hạn, tôi cảm thấy chúng phù hợp với khả năng trả nợ của mình, vì vậy tôi cảm thấy thoải mái hơn khi đăng ký.”",
        },
        {
          name: "Võ Thanh Bình",
          text: "“Lương về theo tháng nên đôi lúc cần xoay thêm chi tiêu. Tôi dùng ứng dụng để xem trước khoản vay, thấy thông tin rõ ràng nên đăng ký cũng nhanh hơn.”",
        },
        {
          name: "Lê Thị Ngọc",
          text: "“Điều hành một doanh nghiệp nhỏ thường đòi hỏi dòng tiền ngắn hạn. Ứng dụng này cung cấp các điều khoản trả nợ linh hoạt, không giống như một số nền tảng khác yêu cầu trả nợ trong vòng một hoặc hai tháng. Có thêm thời gian để quản lý thu nhập sẽ giảm đáng kể áp lực trả nợ.”",
        },
      ],
    };
  },
  methods: {
    toggleQaItem(index) {
      this.activeQaIndex = this.activeQaIndex === index ? -1 : index;
    },
    validateContactForm() {
      const errors = {};

      if (!this.contactForm.name) {
        errors.name = "Vui lòng nhập họ và tên";
      }

      if (!this.contactForm.phone) {
        errors.phone = "Vui lòng nhập số điện thoại";
      }

      if (!this.contactForm.email) {
        errors.email = "Vui lòng nhập email";
      }

      if (!this.contactForm.message) {
        errors.message = "Vui lòng nhập nội dung tin nhắn";
      }

      return errors;
    },
    clearContactError(field) {
      if (!this.contactErrors[field]) {
        return;
      }

      const nextErrors = { ...this.contactErrors };
      delete nextErrors[field];
      this.contactErrors = nextErrors;
    },
    resetContactForm() {
      this.contactForm = createEmptyContactForm();
      this.contactAudience = "personal";
      this.contactErrors = {};
    },
    handleContactSubmit() {
      if (this.isContactSubmitting) {
        return;
      }

      const errors = this.validateContactForm();
      this.contactErrors = errors;

      if (Object.keys(errors).length) {
        return;
      }

      this.isContactSubmitting = true;

      if (this.contactSubmitTimer) {
        clearTimeout(this.contactSubmitTimer);
      }

      this.contactSubmitTimer = setTimeout(() => {
        this.resetContactForm();
        this.isContactSuccessVisible = true;
        this.isContactSubmitting = false;
        this.contactSubmitTimer = null;
      }, 1000);
    },
    closeContactSuccess() {
      this.isContactSuccessVisible = false;
    },
  },
  beforeDestroy() {
    if (this.contactSubmitTimer) {
      clearTimeout(this.contactSubmitTimer);
    }
  },
};
</script>


<style scoped>
.imgBox {
  display: flex;
  flex-direction: column;
  background-color: #fefefe;
}

.imgBox1 {
  display: flex;
  justify-content: center;
  width: 100%;
  min-width: 1400px;
  background-color: "";
}

.imgBox2 {
  display: flex;
  justify-content: center;
  max-width: 1400px;
  padding-top: 40px;
  padding-bottom: 20px;
  height: auto;
  background-color: #FFFFFF;
  border-radius: 32px;
  margin: -140px auto 150px;
}

.imgBox3 {
  display: flex;
  justify-content: center;
  width: 100%;
  min-width: 1400px;
  background-color: "";
}

.imgBox5 {
  display: flex;
  justify-content: center;
  width: 100%;
  min-width: 1400px;
  padding: 76px 0 92px;
  background: linear-gradient(180deg, #ffffff 0%, #fafbfd 100%);
}

img {
  display: block;
}

.img1 {
  overflow: hidden;
  width: 100%;
  position: relative;
}
.img1 .bannerTitle{
  position: absolute;
  top: 30%;
  left: 25%;
  transform: translate(-50%, -50%);
   font-size: 40px;
  font-weight: 800;
  line-height: 1.1;
}

.img2,
.img4,
.img5 {
  overflow: hidden;
  width: 100%;
}

.img3 {
  width: 100%;
  overflow: hidden;
  margin-left: 0;
  margin-right: 0;
  padding: 28px 34px 84px;
}

.imgItem1 {
  width: 100%;
  margin-top: 0;
  margin-bottom: 0;
}

.imgItem2 {
  max-width: 100%;
}

.imgItem3 {
  width: 100%;
  overflow: hidden;
  margin-left: 0;
  margin-right: 0;
}

h1 {
  margin-top: 50px;
  margin-left: 490px;
  color: #3F4842;
  font-size: 40px;
  /* border-bottom: 5px solid #04358A; */
  display: inline-block;
}

.textBox {
  /* margin-top: 50px; */
  margin-left: 100px;
  margin-right: 100px;
  font-size: 18px;
  color: #333333;
}

.imgBox2 {
  transform: none;
  margin: -220px auto 0;
  height: auto;
  /* box-shadow:0 2px 8px rgba(0, 0, 0, 0.25); */
}

.title-line {
  width: 430px;
  /* background: url(./components/img/Group1.png); */
  /* background-repeat: no-repeat; */
  /* background-position: -150px 10px; */
  /* height: 50px; */
  /* border: 1px solid red; */
  border: 5px solid #0BAF60;
  margin: 0 500px;
}

.img1 {
  /* margin-top: 50px; */
  /* padding: 0 200px; */
}

.feature-section {
  padding: 46px 34px 72px;
}

.feature-section__header {
  margin-bottom: 30px;
  text-align: center;
}

.feature-section__title {
  margin: 0;
  color: #3f4842;
  font-size: 56px;
  font-weight: 800;
  line-height: 1.1;
}

.feature-list {
  display: flex;
  flex-direction: column;
  gap: 22px;
}

.feature-card {
  display: grid;
  grid-template-columns: 380px minmax(0, 1fr);
  align-items: center;
  gap: 42px;
  min-height: 470px;
  padding: 26px 56px;
  background: #ffffff;
  border-radius: 54px;
  box-shadow: 0 16px 40px rgba(15, 23, 42, 0.05);
}

.feature-card--reverse {
  grid-template-columns: minmax(0, 1fr) 380px;
}

.feature-card--reverse .feature-card__visual {
  order: 2;
}

.feature-card--reverse .feature-card__content {
  order: 1;
}

.feature-card__visual {
  position: relative;
  display: flex;
  justify-content: center;
  align-items: flex-start;
  width: 100%;
  max-width: 340px;
  height: 450px;
  overflow: hidden;
  border-radius: 30px;
  background: linear-gradient(180deg, #ffffff 0%, #f6f7fb 100%);
  box-shadow:
    inset 0 0 0 1px rgba(15, 23, 42, 0.04),
    0 14px 28px rgba(15, 23, 42, 0.06);
}

.feature-card__image {
  width: 108%;
  max-width: none;
  height: 470px;
  object-fit: cover;
  object-position: top center;
  border-radius: 30px;
  transform: translateY(-2px) scale(1.02);
  transform-origin: top center;
  filter: drop-shadow(0 16px 24px rgba(15, 23, 42, 0.12));
}

.feature-card__content {
  display: flex;
  flex-direction: column;
  align-items: flex-start;
}

.feature-card__title {
  margin: 0 0 14px;
  color: #111827;
  font-size: 38px;

  line-height: 1.2;
}

.feature-card__text {
  margin: 0 0 24px;
  max-width: 620px;
  color: #111827;
  font-size: 20px;
  line-height: 1.6;
}

.feature-card__button {
  display: inline-flex;
  align-items: center;
  gap: 10px;
  padding: 14px 24px;
  border: none;
  border-radius: 999px;
  background: #244ee8;
  color: #ffffff;
  font-size: 18px;
  font-weight: 700;
  line-height: 1;
  cursor: pointer;
  transition: transform 0.2s ease, box-shadow 0.2s ease;
}

.feature-card__button:hover {
  transform: translateY(-2px);
  box-shadow: 0 14px 28px rgba(239, 35, 60, 0.22);
}

.review-section {
  width: 100%;
}

.review-section__header {
  margin-bottom: 34px;
}

.review-section__title {
  margin: 0;
  color: #050505;
  font-size: 58px;
  font-weight: 800;
  line-height: 1.1;
}

.review-hero {
  display: grid;
  grid-template-columns: minmax(0, 1.1fr) 360px;
  gap: 36px;
  align-items: center;
  /* min-height: 420px; */
  height: 680px;
  padding: 42px 42px;
  background: url(@/page/lavifinancecompany/components/img/banner-5.png) no-repeat center center;
  /* border-radius: 64px; */
  overflow: hidden;
  position: relative;
}

.review-hero::before,
.review-hero::after {
  position: absolute;
  width: 88px;
  height: 88px;
  content: "";
  background: rgba(255, 255, 255, 0.12);
  border-radius: 50%;
}

.review-hero::before {
  top: 40px;
  right: 88px;
}

.review-hero::after {
  right: 24px;
  top: 120px;
}

.review-hero__content {
  position: relative;
  z-index: 1;
  color: #ffffff;
}

.review-hero__logo {
  display: inline-flex;
  flex-direction: column;
  align-items: flex-start;
  justify-content: center;
  width: 78px;
  height: 78px;
  margin-bottom: 26px;
  padding-left: 12px;
  background: #ffffff;
  border-radius: 14px;
  color:#244ee8;
  font-size: 16px;
  font-weight: 800;
  line-height: 1;
}

.review-hero__title {
  margin: 0 0 12px;
  margin-bottom: 30px;
  font-size: 58px;
  font-weight: 800;
  line-height: 1.4;
}

.review-hero__text {
  margin: 0 0 28px;
  max-width: 760px;
  color: rgba(0, 0, 0, 0.94);
  font-size: 22px;
  line-height: 1.55;
}

.review-hero__ratings {
  display: flex;
  flex-wrap: wrap;
  gap: 42px;
  margin-bottom: 28px;
}

.store-rating {
  display: inline-flex;
  align-items: center;
  gap: 10px;
  color: #ffffff;
}

.store-rating__icon {
  display: inline-flex;
  align-items: center;
  justify-content: center;
  width: 34px;
  height: 34px;
  border-radius: 10px;
  background: #ffffff;
  font-size: 18px;
  font-weight: 800;
}

.store-rating__icon--apple {
  color: #2563eb;
}

.store-rating__icon--play {
  color: #244ee8;
}

.store-rating__score {
  font-size: 28px;
  font-weight: 800;
  line-height: 1;
}

.store-rating__count {
  font-size: 22px;
  font-weight: 600;
  line-height: 1.3;
}

.review-hero__button {
  display: inline-flex;
  align-items: center;
  gap: 10px;
  padding: 16px 28px;
  border: none;
  border-radius: 999px;
  background:  #244ee8;
  color:#ffffff;
  font-size: 20px;
  font-weight: 700;
  line-height: 1;
  cursor: pointer;
  transition: transform 0.2s ease, box-shadow 0.2s ease;
}

.review-hero__button:hover {
  transform: translateY(-2px);
  box-shadow: 0 16px 28px rgba(0, 0, 0, 0.12);
}

.review-hero__banner-placeholder {
  position: relative;
  z-index: 1;
  display: flex;
  align-items: center;
  justify-content: center;
  min-height: 280px;
  border: 2px dashed rgba(255, 255, 255, 0.38);
  border-radius: 36px;
  background: rgba(255, 255, 255, 0.08);
  color: rgba(255, 255, 255, 0.82);
  font-size: 24px;
  font-weight: 700;
  text-transform: uppercase;
}

.review-cards {
  display: grid;
  grid-template-columns: repeat(4, minmax(0, 1fr));
  gap: 24px;
  margin-top: 42px;
}

.review-card {
  min-height: 286px;
  padding: 28px 24px 26px;
  background: #ffffff;
  border-radius: 34px;
  box-shadow: 0 16px 36px rgba(15, 23, 42, 0.05);
}

.review-card__name {
  margin: 0 0 20px;
  color: #3f4842;
  font-size: 28px;
  font-weight: 700;
  line-height: 1.2;
}

.review-card__stars {
  margin-bottom: 16px;
  color: #f59e0b;
  font-size: 30px;
  letter-spacing: 4px;
  line-height: 1;
}

.review-card__text {
  margin: 0;
  color: #4b5563;
  font-size: 18px;
  line-height: 1.7;
}

.review-section__pager {
  display: flex;
  justify-content: center;
  gap: 12px;
  margin-top: 34px;
}

.review-section__pager-btn {
  width: 56px;
  height: 56px;
  border: 1px solid #9ca3af;
  border-radius: 50%;
  background: #ffffff;
  color: #6b7280;
  font-size: 28px;
  line-height: 1;
  cursor: pointer;
}

.review-section__pager-btn:hover {
  border-color: #244ee8;
  color: #244ee8;
}

.contact-section {
  display: grid;
  grid-template-columns: 400px minmax(0, 1fr);
  gap: 54px;
  align-items: start;
  width: 100%;
  padding: 0 34px;
}

.contact-section__info {
  padding-top: 18px;
}

.contact-info-card {
  display: flex;
  align-items: flex-start;
  gap: 18px;
}

.contact-info-card + .contact-info-card {
  margin-top: 28px;
}

.contact-info-card__icon {
  flex: 0 0 auto;
  display: inline-flex;
  align-items: center;
  justify-content: center;
  width: 38px;
  height: 38px;
  color: #244ee8;
}

.contact-info-card__icon svg {
  width: 30px;
  height: 30px;
  stroke: currentColor;
  stroke-width: 1.8;
  stroke-linecap: round;
  stroke-linejoin: round;
}

.contact-info-card__body {
  display: flex;
  flex-direction: column;
  gap: 6px;
  padding-top: 1px;
}

.contact-info-card__body--inline {
  flex-direction: row;
  align-items: baseline;
  flex-wrap: wrap;
  gap: 10px;
}

.contact-info-card__title {
  margin: 0;
  color: #1f2c48;
  font-size: 30px;
  font-weight: 700;
  line-height: 1.45;
}

.contact-info-card__text,
.contact-info-card__link,
.contact-info-card__email {
  margin: 0;
  color: #1f2c48;
  font-size: 20px;
  line-height: 1.55;
  text-decoration: none;
}

.contact-info-card__link:hover,
.contact-info-card__email:hover {
  color: #244ee8;
}

.contact-info-card__hotline {
  color: #244ee8;
  font-size: 28px;
  font-weight: 800;
  line-height: 1.2;
  text-decoration: none;
}

.contact-form-shell {
  display: flex;
  justify-content: flex-end;
}

.contact-form-card {
  width: 100%;
  max-width: 760px;
  padding: 34px 42px 32px;
  background: #ffffff;
  border-radius: 22px;
  box-shadow: 0 24px 50px rgba(31, 44, 72, 0.12);
}

.contact-form-card__tab {
  display: inline-grid;
  grid-template-columns: minmax(0, 1fr) 126px;
  min-width: 326px;
  overflow: hidden;
  border: 1px solid #b8c5df;
  border-radius: 16px;
}

.contact-form-card__tab-label {
  display: flex;
  align-items: center;
  justify-content: center;
  min-height: 54px;
  padding: 0 34px;
  background: #f20e2f;
  color: #ffffff;
  font-size: 20px;
  font-weight: 700;
}

.contact-form-card__tab-icon {
  display: flex;
  align-items: center;
  justify-content: center;
  background: #ffffff;
  color: #244ee8;
}

.contact-form-card__tab-icon svg {
  width: 30px;
  height: 30px;
  stroke: currentColor;
  stroke-width: 1.8;
  stroke-linecap: round;
  stroke-linejoin: round;
}

.contact-form-card__intro {
  margin: 26px 0 40px;
  color: #1f2c48;
  font-size: 20px;
  line-height: 1.7;
}

.contact-form {
  display: flex;
  flex-direction: column;
  gap: 18px;
}

.contact-form__audience {
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: 20px;
  margin-bottom: 2px;
}

.contact-form__audience-label {
  color: #1f2c48;
  font-size: 20px;
  font-weight: 700;
}

.contact-form__audience-options {
  display: flex;
  align-items: center;
  gap: 36px;
}

.contact-type {
  position: relative;
  display: inline-flex;
  align-items: center;
  gap: 10px;
  cursor: pointer;
}

.contact-type__input {
  position: absolute;
  opacity: 0;
  pointer-events: none;
}

.contact-type__control {
  position: relative;
  width: 22px;
  height: 22px;
  border: 1.5px solid #c7cedd;
  border-radius: 50%;
  background: #ffffff;
  transition: border-color 0.2s ease;
}

.contact-type__control::after {
  position: absolute;
  top: 50%;
  left: 50%;
  width: 10px;
  height: 10px;
  content: "";
  background: #1f6feb;
  border-radius: 50%;
  transform: translate(-50%, -50%) scale(0);
  transition: transform 0.2s ease;
}

.contact-type__input:checked + .contact-type__control {
  border-color: #1f6feb;
}

.contact-type__input:checked + .contact-type__control::after {
  transform: translate(-50%, -50%) scale(1);
}

.contact-type__text {
  color: #1f2c48;
  font-size: 20px;
  line-height: 1.4;
}

.contact-form__row {
  display: flex;
}

.contact-form__row--half {
  gap: 18px;
}

.contact-form__field-group {
  flex: 1 1 0;
}

.contact-form__field-group--full {
  width: 100%;
}

.contact-field {
  position: relative;
  display: flex;
  align-items: center;
  flex: 1 1 0;
  min-height: 62px;
  padding: 0 22px 0 18px;
  background: #f5f7fb;
  border: 1px solid #eef2f8;
  border-radius: 18px;
}

.contact-field--full {
  width: 100%;
}

.contact-field--textarea {
  align-items: flex-start;
  min-height: 192px;
  padding-top: 18px;
}

.contact-field--error {
  border-color: rgba(239, 35, 60, 0.4);
  background: #fff8f8;
  box-shadow: 0 0 0 3px rgba(239, 35, 60, 0.08);
}

.contact-field__icon {
  flex: 0 0 auto;
  display: inline-flex;
  align-items: center;
  justify-content: center;
  width: 32px;
  height: 32px;
  margin-right: 14px;
  color: #a8afbf;
}

.contact-field__icon svg {
  width: 24px;
  height: 24px;
  stroke: currentColor;
  stroke-width: 1.8;
  stroke-linecap: round;
  stroke-linejoin: round;
}

.contact-field__input {
  flex: 1 1 auto;
  width: 100%;
  min-width: 0;
  padding: 0;
  border: none;
  background: transparent;
  color: #1f2c48;
  font-size: 16px;
  line-height: 1.5;
  outline: none;
}

.contact-field__input::placeholder,
.contact-field__textarea::placeholder {
  color: #8993a7;
}

.contact-field__textarea {
  resize: vertical;
  min-height: 150px;
  padding-top: 4px;
  font-family: inherit;
}

.contact-field__input:disabled {
  cursor: not-allowed;
}

.contact-field__error {
  display: block;
  margin-top: 8px;
  padding-left: 8px;
  color: #244ee8;
  font-size: 13px;
  line-height: 1.45;
}

.contact-form__actions {
  display: flex;
  justify-content: center;
  padding-top: 4px;
}

.contact-form__submit {
  display: inline-flex;
  align-items: center;
  justify-content: center;
  gap: 14px;
  min-width: 160px;
  min-height: 52px;
  padding: 0 34px;
  border: none;
  border-radius: 999px;
  background: linear-gradient(180deg, #ffd85f 0%, #ffc62d 100%);
  color: #1f2c48;
  font-size: 18px;
  font-weight: 700;
  cursor: pointer;
  transition: transform 0.2s ease, box-shadow 0.2s ease;
}

.contact-form__submit:hover {
  transform: translateY(-2px);
  box-shadow: 0 16px 28px rgba(255, 198, 45, 0.34);
}

.contact-form__submit:disabled {
  cursor: not-allowed;
  opacity: 0.78;
  transform: none;
  box-shadow: none;
}

.contact-form__submit-icon {
  font-size: 22px;
  line-height: 1;
}

.contact-modal {
  position: fixed;
  inset: 0;
  z-index: 999;
  display: flex;
  align-items: center;
  justify-content: center;
  padding: 24px;
  background: rgba(15, 23, 42, 0.4);
}

.contact-modal__dialog {
  position: relative;
  width: 100%;
  max-width: 380px;
  padding: 28px 28px 26px;
  background: #ffffff;
  border-radius: 24px;
  box-shadow: 0 28px 60px rgba(15, 23, 42, 0.18);
  text-align: center;
}

.contact-modal__close {
  position: absolute;
  top: 16px;
  right: 16px;
  width: 32px;
  height: 32px;
  border: none;
  border-radius: 50%;
  background: #f3f5fa;
  color: #667085;
  font-size: 22px;
  line-height: 1;
  cursor: pointer;
}

.contact-modal__badge {
  display: inline-flex;
  align-items: center;
  justify-content: center;
  width: 62px;
  height: 62px;
  margin-bottom: 18px;
  border-radius: 50%;
  background: linear-gradient(180deg, #24c86a 0%, #14ae57 100%);
  color: #ffffff;
  font-size: 30px;
  font-weight: 700;
}

.contact-modal__title {
  margin: 0 0 10px;
  color: #1f2c48;
  font-size: 24px;
  font-weight: 800;
  line-height: 1.3;
}

.contact-modal__text {
  margin: 0 0 22px;
  color: #4b5563;
  font-size: 15px;
  line-height: 1.7;
}

.contact-modal__button {
  min-width: 132px;
  min-height: 46px;
  padding: 0 22px;
  border: none;
  border-radius: 999px;
  background: linear-gradient(180deg, #ffd85f 0%, #ffc62d 100%);
  color: #1f2c48;
  font-size: 16px;
  font-weight: 700;
  cursor: pointer;
}

@media (max-width: 1200px) {
  .feature-card,
  .feature-card--reverse {
    grid-template-columns: 1fr;
    gap: 28px;
    padding: 28px 30px;
  }

  .feature-card--reverse .feature-card__visual,
  .feature-card--reverse .feature-card__content {
    order: initial;
  }

  .review-hero {
    grid-template-columns: 1fr;
  }

  .review-cards {
    grid-template-columns: repeat(2, minmax(0, 1fr));
  }

  .contact-section {
    grid-template-columns: 1fr;
    gap: 32px;
  }

  .contact-section__info {
    padding-top: 0;
  }

  .contact-form-shell {
    justify-content: flex-start;
  }
}

@media (max-width: 768px) {
  .feature-section {
    padding: 30px 18px 48px;
  }

  .feature-section__title {
    font-size: 40px;
  }

  .feature-card {
    min-height: 0;
    padding: 24px 22px;
    border-radius: 34px;
  }

  .feature-card__title {
    font-size: 30px;
  }

  .feature-card__text {
    font-size: 18px;
  }

  .feature-card__image {
    width: 106%;
    height: 220px;
    transform: translateY(0) scale(1.01);
  }

  .img3 {
    padding: 22px 18px 56px;
  }

  .review-section__title {
    font-size: 40px;
  }

  .review-hero {
    min-height: 0;
    padding: 28px 24px;
    border-radius: 34px;
  }

  .review-hero__title {
    font-size: 36px;
  }

  .review-hero__text,
  .store-rating__count {
    font-size: 18px;
  }

  .store-rating__score {
    font-size: 22px;
  }

  .review-cards {
    grid-template-columns: 1fr;
  }

  .review-card {
    min-height: 0;
  }

  .imgBox5 {
    padding: 48px 0 60px;
  }

  .contact-section {
    padding: 0 18px;
  }

  .contact-info-card__title {
    font-size: 18px;
  }

  .contact-info-card__text,
  .contact-info-card__link,
  .contact-info-card__email {
    font-size: 16px;
  }

  .contact-info-card__hotline {
    font-size: 24px;
  }

  .contact-form-card {
    padding: 26px 20px 24px;
    border-radius: 18px;
  }

  .contact-form-card__tab {
    min-width: 0;
    width: 100%;
    grid-template-columns: minmax(0, 1fr) 88px;
  }

  .contact-form-card__tab-label {
    padding: 0 18px;
    font-size: 16px;
  }

  .contact-form-card__intro {
    margin: 20px 0 28px;
  }

  .contact-form__audience {
    flex-direction: column;
    align-items: flex-start;
  }

  .contact-form__audience-options,
  .contact-form__row--half {
    width: 100%;
    gap: 14px;
  }

  .contact-form__row--half {
    flex-direction: column;
  }

  .contact-field {
    min-height: 58px;
    padding-right: 18px;
  }

  .contact-field--textarea {
    min-height: 170px;
  }
}
 /* Common Utils */
        .transition-all { transition: all 0.3s ease; }
        .transition-transform { transition: transform 0.3s ease; }
        .shadow-sm-hover:hover { box-shadow: 0 .5rem 1rem rgba(0,0,0,.08)!important; transform: translateY(-2px); }
        
        
        /* Classic Style Specifics */
        .accordion-button:not(.collapsed) {
            color: #3b82f6;
            background-color: rgba(59, 130, 246, 0.08);
            box-shadow: inset 0 -1px 0 rgba(0,0,0,.125);
        }
        .accordion-button:focus {
            border-color: #3b82f6;
            box-shadow: 0 0 0 0.25rem rgba(59, 130, 246, 0.25);
        }

        .accordion-button{
          font-size: 25px;
        }

        .accordion-item {
            border-color: rgba(0,0,0,0.08);
            font-size: 20px;
        }

        .qa-answer {
            line-height: 1.6;
        }

        .qa-answer__paragraph {
            margin: 0;
        }

        .qa-answer__paragraph + .qa-answer__paragraph {
            margin-top: 12px;
        }
        
</style>
